import { createTrackingUtils } from "../index";
import { RouteName } from "app/routes";

const utils = createTrackingUtils({
  name: "flights_apex_web_bf_icons_v3",
  stages: {
    affected_user: 1,
    main: 2,
    ddot: 3,
    mdot: 4,
    bf_page: 5,
    check_and_pay: 6,
    sees_exclusions: 7,
    sees_sellable: 8,
    upsell_prompt: 9
  },
  goals: {},
  defaultStage: 1
});

const trackStages = ({
  isMobile,
  routeName,
  hasExcludedFeatures,
  hasSellableFeatures
}: {
  isMobile: boolean;
  routeName: RouteName;
  hasExcludedFeatures: boolean;
  hasSellableFeatures: boolean;
}) => {
  utils.stages.main();
  isMobile ? utils.stages.mdot() : utils.stages.ddot();
  if (routeName === "checkout-payment") utils.stages.check_and_pay();
  if (routeName === "checkout-fare") utils.stages.bf_page();
  if (hasExcludedFeatures) utils.stages.sees_exclusions();
  if (hasSellableFeatures) utils.stages.sees_sellable();
};

export default { trackStages, ...utils };
